

export const index = 1;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/fallbacks/error.svelte.js')).default;
export const imports = ["_app/immutable/nodes/1.CXxYw9M2.js","_app/immutable/chunks/C-JP16Co.js","_app/immutable/chunks/BtrLzPHK.js","_app/immutable/chunks/BLCO_5as.js","_app/immutable/chunks/DwLu_C6_.js","_app/immutable/chunks/DiB57FwD.js","_app/immutable/chunks/CuSt24Z6.js"];
export const stylesheets = [];
export const fonts = [];
